import { useTranslation } from 'react-i18next'
import { CrossIcon, useClickOutside } from '@honestica/curecall-ui'
import { SetStateAction, useRef } from 'react'
import { ReactQuillDynamic } from './react-quill-editor'
import { TContent } from './content.type'
import { getPreviewUrl } from './content-list.util'
import { useLocale } from 'src/hooks/use-locale'

const PreviewModal = ({
  callback,
  children,
}: Readonly<{
  callback: (value: any) => void
  children: React.ReactNode
}>) => {
  const { t } = useTranslation()
  const dialogRef = useRef(null)

  useClickOutside({ ref: dialogRef, callBack: () => callback(null) })

  return (
    <div className="c-fixed c-left-0 c-top-0 c-z-[60] c-min-h-[100vh] c-min-w-[100vw] c-w-full c-h-full c-bg-[rgba(120,120,120,0.1)]">
      <dialog
        ref={dialogRef}
        className="c-fixed c-top-[2vh] c-z-[60] c-flex c-shadow-xl c-drop-shadow-[0_0_200px_rgba(128,128,128,0.1)] c-w-[398px] c-h-[780px] c-max-h-[96vh] c-rounded-[3.5rem] c-bg-[url('public/assets/img/phone.jpg')] c-bg-local c-bg-cover c-bg-no-repeat"
      >
        <button
          onClick={() => callback(null)}
          className="c-absolute c-z-60 c--right-6 c-top-0 c-rounded-full c-bg-grey-700 c-p-1.5 c-text-white hover:c-bg-grey-700 hover:c-text-white hover:c-shadow-2xl focus:c-bg-grey-700"
          aria-label={t('common.actions.close')}
        >
          <CrossIcon className="c-h-4" />
        </button>
        <div className="c-w-full c-mt-14 c-mx-[1.45rem] c-mb-10 c-bg-grey-100 c-border c-border-grey-100">
          {children}
        </div>
      </dialog>
    </div>
  )
}

const ContentViewModal = ({
  contentToShow,
  setContentToShow,
}: Readonly<{
  contentToShow: TContent | null
  setContentToShow: (value: SetStateAction<TContent | null>) => void
}>) => {
  const { locale } = useLocale()
  const { t } = useTranslation()

  const url = getPreviewUrl(contentToShow, locale)

  return (
    <PreviewModal callback={setContentToShow}>
      {url ? (
        <iframe title={`Preview-content-${contentToShow?.id}`} src={url} className="c-w-full c-h-full" />
      ) : (
        <p className="c-font-nexa c-align-middle c-mt-[50%] c-text-center c-w-full c-text-lg">
          {t('pages.configuration.contents.cannot-preview')}
        </p>
      )}
    </PreviewModal>
  )
}

const ContentHTMLPreviewModal = ({
  previewToShow,
  setPreviewToShow,
}: Readonly<{
  previewToShow: string | null
  setPreviewToShow: (value: SetStateAction<string | null>) => void
}>) => {
  return (
    <PreviewModal callback={setPreviewToShow}>
      <ReactQuillDynamic
        theme="bubble"
        readOnly={true}
        modules={{
          toolbar: false,
          clipboard: { matchVisual: false },
        }}
        value={previewToShow}
        className="c-h-full"
      />
    </PreviewModal>
  )
}

export { ContentViewModal, ContentHTMLPreviewModal }
